import React from 'react';
import { trackClick } from 'utility/analytics';
import { XXL, LG, MD } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';
import Flex, { FlexItem } from 'styled-flex-component';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { Button } from 'theme/Button';
import ContactUsForm from 'components/BasicForms/ContactUsFormTwo';

import {
  Wrapper, 
  ContactSection,
  ContactUsFormWrapper,
  
} from '../../Contact.styles';

const ContactForm = (props) => {
  return (
    <ContactSection>
        <Wrapper>
          <Grid>
            <Row justifyContent="center">
              <Col md={6} size={12}>
                <ContactUsFormWrapper>
                  <ContactUsForm title={true}/>

                  <MD left paddingBottomMd className="email-link" tag="p"><a onClick={() => trackClick('callUs', '440-942-2922')} href="tel:440-942-2922" style={{marginBottom: '10px', color: `#414141`}}>Phone: 440.942.2922</a></MD>
                  <MD left className="email-link" tag="p"><a onClick={() => trackClick('emailUs', 'sales@mritechnologies.com')} href="mailto:sales@mritechnologies.com" style={{color: `#414141`}}>Email: sales@mritechnologies.com</a></MD>
                </ContactUsFormWrapper>
              </Col>
            </Row>
           
          </Grid>
        </Wrapper>
      </ContactSection>

  )
}

export default ContactForm;